
import React, { useState, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HttpClient from '../utils/HttpClient';
import './termscondition.css';
import DataTable from 'react-data-table-component';

const TermsCondition = () => {
  const [termsContent, setTermsContent] = useState('');
  const [savedTermsContent, setSavedTermsContent] = useState('');
  const [privacyContent, setPrivacyContent] = useState('');
  const [savedPrivacyContent, setSavedPrivacyContent] = useState('');
  const [isTermsEditing, setIsTermsEditing] = useState(true); // Track editing mode for terms
  const [isPrivacyEditing, setIsPrivacyEditing] = useState(true); // Track editing mode for privacy policy
  const [id, setId] = useState(null); // Track ID for PUT request
  const [allData, setAllData] = useState([]);
  const [isEdit, setIsEdit] = useState(false)

  const editorConfiguration = {
    toolbar: [
      'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote',
      'undo', 'redo', 'alignment', 'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor',
      'imageUpload', 'mediaEmbed', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells',
      'highlight', 'removeFormat'
    ]
  };

  // DataTable Columns Definition
  const columns = [
    {
      name: 'SL',
      selector: row => row.sln,
      sortable: true,
      wrap: true
    },
    {
      name: 'Terms & Condition',
      selector: row => row.TermsAndCondition,
      sortable: true,
      wrap: true,
      cell: row => <div dangerouslySetInnerHTML={{ __html: row.TermsAndCondition }} />
    },
    {
      name: 'Privacy Policy',
      selector: row => row.privacyAndPolicy,
      sortable: true,
      wrap: true,
      cell: row => <div dangerouslySetInnerHTML={{ __html: row.privacyAndPolicy }} />
    },
    {
      name: 'Action',
      selector: row => row.action,
      sortable: true,
      wrap: true
    },
  ];

  // Fetch Terms & Conditions and Privacy Policy content
  const fetchTermsContent = async () => {
    try {
      const response = await HttpClient.requestData('terms-privacy', 'GET');
      if (response && response.status) {
        const { data } = response;

        const transformedData = [
          {
            sln: 0 + 1,
            id: data._id,
            TermsAndCondition: data.TermsAndCondition,
            privacyAndPolicy: data.privacyAndPolicy,
            action: (
              <span onClick={() => handleEdit(data)} style={{ cursor: "pointer" }}>
                <i class="fa-solid fa-pen-to-square"></i>
              </span>
            ),
          },
        ];
        setAllData(transformedData);
      }
    } catch (error) {
      console.error('Error fetching Terms & Privacy:', error);
      toast.error('Failed to fetch Terms & Privacy content');
    }
  };

  // >>>>handleEdit<<<<
  const handleEdit = (data) => {
    if (data) {
      setIsEdit(true)
      setId(data._id);
      setTermsContent(data.TermsAndCondition);
      setPrivacyContent(data.privacyAndPolicy);
    } else {
      setIsEdit(false)
      setId("")
    }
    console.log("s654g51", data)
  }

  useEffect(() => {
    fetchTermsContent();
  }, []);

  const handleSave = async () => {
    console.log("dfg45d1", `terms-privacy/${id}`)
    // return
    try {
      // Save Terms & Conditions and Privacy Policy
      const response = await HttpClient.requestData(`terms-privacy/${id}`, 'PUT', {
        TermsAndCondition: termsContent,
        privacyAndPolicy: privacyContent,
      });

      if (response && response.status) {
        setTermsContent(''); // Clear terms editor
        setPrivacyContent(''); // Clear privacy editor
        setIsEdit(false)
        fetchTermsContent()
        toast.success('Terms & Privacy content edited successfully!');
      } else {
        toast.error('Failed to save Terms & Privacy content');
      }
    } catch (error) {
      console.error('Error saving Terms & Privacy:', error);
      toast.error('Failed to save Terms & Privacy content');
    }
  };

  return (
    <div className="terms-condition-container">
      {isEdit &&
        <>
          <b>{isEdit ? "Update Terms & Condition" : "Terms & Condition"}</b>
          <div className="editor-wrapper mb-4">
            <CKEditor
              editor={ClassicEditor}
              config={editorConfiguration}
              data={termsContent}
              onChange={(event, editor) => {
                const data = editor.getData();
                setTermsContent(data);
              }}
            />
          </div>

          <b >{isEdit ? "Update Privacy Policy" : "Privacy Policy"}</b>
          <div className="editor-wrapper">
            <CKEditor
              editor={ClassicEditor}
              config={editorConfiguration}
              data={privacyContent}
              onChange={(event, editor) => {
                const data = editor.getData();
                setPrivacyContent(data);
              }}
            />
          </div>

          <button onClick={handleSave} className="btn-save mb-2" style={{ marginTop: '20px', backgroundColor: 'rgb(208, 38, 38)' }}>Update</button>
        </>
      }

      <ToastContainer />

      {/* DataTable */}
      <div className='mt-2 shadow-lg'>
        <h2 className='p-3 d-flex justify-content-center' style={{ color: "#ccc", fontWeight: "bold" }}>View Terms&Condition</h2>
        <DataTable
          columns={columns}
          data={allData}
          pagination
          responsive
          highlightOnHover
        />
      </div>

      {/* Footer */}
      <footer style={{ position: 'fixed', bottom: '0', width: '100%', padding: '10px 0', zIndex: '1', backgroundColor: '#fff' }}>
        <p style={{ fontSize: '12px', color: '#666' }}>Copyright © 2024 Psedge. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default TermsCondition;

